export const itemList = {
  "status": 0,
  "data": [{
    "id": 9,
    "name": "商品1",
    "itemLink": "http://mall.maizuo.com/#!/item/oxDQyfbEyjYR",
    "itemPic": "http://pic.maizuo.com/manager/76438b6b7dd4767a31c2ea0e95b2c2f9.jpg"
  }, {
    "id": 7,
    "name": "商品2",
    "itemLink": "http://mall.maizuo.com/#!/item/osjbKRtnsImZ",
    "itemPic": "http://pic.maizuo.com/manager/fb032c29c73194915cb2129ba6308e03.jpg"
  }, {
    "id": 2,
    "name": "商品3",
    "itemLink": "http://mall.maizuo.com/#!/item/MxUfrzTPTQSv",
    "itemPic": "http://pic.maizuo.com/manager/c7f42c546ee3238f797c91493ae25c8a.jpg"
  }, {
    "id": 8,
    "name": "商品4",
    "itemLink": "http://mall.maizuo.com/#!/item/OUPEySLatfmO",
    "itemPic": "http://pic.maizuo.com/manager/c66592632e20a9684112ab4773494e5e.jpg"
  }],
  "msg": ""
}

